import React, { useEffect, useState } from 'react';
import './PeakDaySlide.css';
import ProgressMeter from '../ProgressMeter/ProgressMeterTutor';
import { globalText, resolveTutorHomeAsset } from '../tutorHomeConfig';

function PeakDaySlide({ data, campaignOrg, config = {} }) {
	const [secondsRemaining, setSecondsRemaining] = useState(0);
	const text = config.text || {};
	const images = config.images || {};
	const organizationName = campaignOrg?.orgName || campaignOrg?.name;
	const organizationLogo = campaignOrg?.orgLogo || campaignOrg?.logo;
	const organizationLocation = campaignOrg?.cityName || campaignOrg?.city || campaignOrg?.location;

	useEffect(() => {
		const rawEndTime = Array.isArray(data?.endTime)
			? [...data.endTime].reverse().find((value) => value !== null && value !== undefined)
			: data?.endTime;
		const duration = Math.max(0, Number(rawEndTime) || 0);
		setSecondsRemaining(duration);

		if (!duration) return undefined;
		const timerId = setInterval(() => {
			setSecondsRemaining((remaining) => Math.max(0, remaining - 1));
		}, 1000);
		return () => clearInterval(timerId);
	}, [data?.endTime]);

	const hours = Math.floor(secondsRemaining / 3600);
	const minutes = Math.floor((secondsRemaining % 3600) / 60);
	const seconds = secondsRemaining % 60;
	const formattedTime = [hours, minutes, seconds]
		.map((value) => String(value).padStart(2, '0'))
		.join(':');

	return (
		<div className="slideCard slideCardPeakDay">
			<div className="cardBody">
				<div className="peakDayHeaderArtwork">
					<img src={resolveTutorHomeAsset(images.header_artwork)} alt="Win big this Navratri Week" />
				</div>
				<div className="peakDayRevenueFlex">
					<div className="peakDayRevenueData">
						<img src={resolveTutorHomeAsset(images.revenue_divider)} alt="" />
						<div>
							<h4>{globalText.revenue_label || 'Your Revenue'}</h4>
							<h1>{data?.total}</h1>
						</div>
					</div>
					<div className="peakDayCountdown">
						{text.countdown_label || 'Ends in:'} <span>{formattedTime}</span>
					</div>
				</div>
				<div className="peakDayMeter">
					<ProgressMeter width={data?.progressBar || 0} />
				</div>
				<div className="peakDayProgressLabels">
					<p>{data?.progressBar || 0}{text.progress_suffix || '% complete'}</p>
					<p>{globalText.goal_prefix || 'Goal:'} {data?.goal}</p>
				</div>
				<div className="peakDayOrganizationCard">
					{organizationLogo && <img className="peakDayOrganizationLogo" src={organizationLogo} alt={`${organizationName || 'Organization'} logo`} />}
					{organizationLogo && <span className="peakDayOrganizationLabel">{text.organization_label || 'Company'}</span>}
					{organizationName && <h2>{organizationName}</h2>}
					{organizationLocation && <p><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" /></svg>{organizationLocation}</p>}
				</div>
			</div>
		</div>
	);
}

export default PeakDaySlide;
